class ProductSticky extends HTMLElement {
  connectedCallback() {
    this.listenEvents();
  }

  selectors = {
    footer: document.querySelector('.site-footer'),
    buttonAddToCart: document.querySelector('.product__submit__item'),
    fixedSections: document.querySelectorAll('.section.fixed-bottom')
  };

  stickyAddToCartButton = this.querySelector('.product__submit__add-to-cart');

  listenEvents() {
    window.addEventListener('scroll', (e) => {
      this.classlistToggle();
    });

    this.stickyAddToCartButton &&
      this.stickyAddToCartButton.addEventListener('click', (e) => {
        this.onProductVariantAvailability();
      });
  }

  onProductVariantAvailability() {
    //while struggling to call klaviyo button or atc button,
    //product form is a good alternative to scroll to

    const productForm = document.querySelector('.product-form');
    productForm && productForm.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  classlistToggle() {
    if (this.elementInViewport(this.selectors.footer) || this.elementInViewport(this.selectors.buttonAddToCart)) {
      this.classList.add('hideStickyAddtocart');
      this.classList.remove('showStickyAddtocart');
      this.selectors.fixedSections.forEach((section) => {
        section.closest('.shopify-section').style.display = 'block';
      });
    } else {
      this.classList.add('showStickyAddtocart');
      this.classList.remove('hideStickyAddtocart');
      this.selectors.fixedSections.forEach((section) => {
        section.closest('.shopify-section').style.display = 'none';
      });
    }
  }

  elementInViewport(element) {
    var top = element.offsetTop;
    var height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
    }
    return top < window.scrollY + window.innerHeight && top + height > window.scrollY;
  }
}
customElements.define('sticky-atc', ProductSticky);
